export const community = {
    notice: {
        name: '공지사항',
        hasThumbnail: false,
        icon: 'Bell'
    },
    case: {
        name: '설치시공사례',
        hasThumbnail: true,
        icon: 'Truck'
    },
    library: {
        name: '자료실',
        hasThumbnail: false,
        icon: 'Database',
        hasFile: true
    },
    video: {
        name: '동영상 자료실',
        hasThumbnail: true,
        icon: 'Youtube'
    },
}

export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8001' : 'http://deogu.cafe24app.com';